"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEASUREMENT_FAMILY = exports.GUIDED_LOOKUP_KEY = exports.GUIDED_DIMENSION_TYPE = void 0;
exports.getGuidedDimensionOptions = getGuidedDimensionOptions;
exports.getGuidedTypeLookupKey = getGuidedTypeLookupKey;
exports.getMeasurementFamily = getMeasurementFamily;
exports.guidedTypeLookupKeys = exports.guidedLookupFilterFieldByType = exports.guidedDimensions = void 0;
var _deviceTagMeasurements = require("@kentik/ui-shared/dictionary/v2/compilers/deviceTagMeasurements");
const MEASUREMENT_FAMILY = exports.MEASUREMENT_FAMILY = {
  Traffic: 'traffic',
  NmsInterfaceCounters: 'nmsInterfaceCounters',
  NmsInterfaces: 'nmsInterfaces',
  Nms: 'nms',
  Synthetics: 'synthetics',
  EventsSyslog: 'eventsSyslog',
  EventsSnmpTrap: 'eventsSnmpTrap',
  EventsDeviceConfigChange: 'eventsDeviceConfigChange'
};
function getMeasurementFamily(measurement) {
  if (measurement.startsWith('/events/event_syslog')) {
    return MEASUREMENT_FAMILY.EventsSyslog;
  }
  if (measurement.startsWith('/events/event_snmp_traps')) {
    return MEASUREMENT_FAMILY.EventsSnmpTrap;
  }
  if (measurement.startsWith('/events/event_deviceconf')) {
    return MEASUREMENT_FAMILY.EventsDeviceConfigChange;
  }
  if (measurement === '/metrics/interfaces/counters') {
    return MEASUREMENT_FAMILY.NmsInterfaceCounters;
  }
  if (measurement.startsWith('/metrics/interfaces/')) {
    return MEASUREMENT_FAMILY.NmsInterfaces;
  }
  if (measurement.startsWith('/metrics')) {
    return MEASUREMENT_FAMILY.Nms;
  }
  if (measurement.startsWith('/traffic')) {
    return MEASUREMENT_FAMILY.Traffic;
  }
  if (measurement.startsWith('/synthetics')) {
    return MEASUREMENT_FAMILY.Synthetics;
  }
  return null;
}
const GUIDED_DIMENSION_TYPE = exports.GUIDED_DIMENSION_TYPE = {
  Site: 'Site',
  Device: 'Device',
  Country: 'Country',
  Label: 'Label',
  InterfaceName: 'Interface Name',
  InterfaceDescription: 'Interface Description',
  ASNumber: 'AS Number',
  IPAddress: 'IP Address',
  SyslogFacility: 'Syslog Facility',
  SyslogSeverity: 'Syslog Severity',
  SyslogMessage: 'Syslog Message',
  SnmpTrapType: 'SNMP Trap Type',
  SnmpTrapAgent: 'SNMP Trap Agent',
  DeviceConfigChangeCommitUser: 'Device Config Change Commit User',
  DeviceConfigChangeCommitComment: 'Device Config Change Commit Comment',
  DeviceConfigChangeAgent: 'Device Config Change Agent'
};
const guidedDimensions = exports.guidedDimensions = {
  [GUIDED_DIMENSION_TYPE.Site]: {
    [MEASUREMENT_FAMILY.Traffic]: ['i_device_site_name', 'i_site_market', 'i_ult_exit_site', 'i_ult_exit_site_market'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['i_device_site_name'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['i_device_site_name'],
    [MEASUREMENT_FAMILY.Nms]: ['i_device_site_name']
  },
  [GUIDED_DIMENSION_TYPE.Device]: {
    [MEASUREMENT_FAMILY.Traffic]: ['i_device_id', 'i_device_name', 'i_ult_exit_device_name'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['device_id', 'device_name'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['device_name'],
    [MEASUREMENT_FAMILY.Nms]: ['device_name'],
    [MEASUREMENT_FAMILY.EventsSyslog]: ['ktappprotocol__event_syslog__i_device_name'],
    [MEASUREMENT_FAMILY.EventsSnmpTrap]: ['ktappprotocol__event_snmp_traps__i_device_name'],
    [MEASUREMENT_FAMILY.EventsDeviceConfigChange]: ['ktappprotocol__event_deviceconf__i_device_name']
  },
  [GUIDED_DIMENSION_TYPE.Country]: {
    [MEASUREMENT_FAMILY.Traffic]: ['src_geo', 'dst_geo', 'i_device_site_country', 'i_ult_exit_site_country'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['i_device_site_country'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['i_device_site_country'],
    [MEASUREMENT_FAMILY.Nms]: ['i_device_site_country']
  },
  [GUIDED_DIMENSION_TYPE.Label]: {
    [MEASUREMENT_FAMILY.Traffic]: ['i_device_label'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['i_device_label'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['i_device_label'],
    [MEASUREMENT_FAMILY.Nms]: ['i_device_label'],
    [MEASUREMENT_FAMILY.Synthetics]: ['ktlabel_syn_agent', 'ktlabel_syn_test']
  },
  [GUIDED_DIMENSION_TYPE.InterfaceName]: {
    [MEASUREMENT_FAMILY.Traffic]: ['i_input_interface_description', 'i_output_interface_description', 'i_input|output_interface_description', 'i_ult_exit_interface_description'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['name'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['name'],
    [MEASUREMENT_FAMILY.EventsSnmpTrap]: ['ktappprotocol__event_snmp_traps__STR06']
  },
  [GUIDED_DIMENSION_TYPE.InterfaceDescription]: {
    [MEASUREMENT_FAMILY.Traffic]: ['i_input_snmp_alias', 'i_output_snmp_alias', 'i_input|output_snmp_alias', 'i_ult_exit_snmp_alias']
  },
  [GUIDED_DIMENSION_TYPE.ASNumber]: {
    [MEASUREMENT_FAMILY.Traffic]: ['src_as', 'dst_as', 'src_nexthop_asn', 'dst_nexthop_asn']
  },
  [GUIDED_DIMENSION_TYPE.IPAddress]: {
    [MEASUREMENT_FAMILY.Traffic]: ['inet_src_addr', 'inet_dst_addr'],
    [MEASUREMENT_FAMILY.NmsInterfaceCounters]: ['device_ip'],
    [MEASUREMENT_FAMILY.NmsInterfaces]: ['device_ip'],
    [MEASUREMENT_FAMILY.Nms]: ['device_ip']
  },
  [GUIDED_DIMENSION_TYPE.SyslogFacility]: {
    [MEASUREMENT_FAMILY.EventsSyslog]: ['ktappprotocol__event_syslog__INT05']
  },
  [GUIDED_DIMENSION_TYPE.SyslogSeverity]: {
    [MEASUREMENT_FAMILY.EventsSyslog]: ['ktappprotocol__event_syslog__INT06']
  },
  [GUIDED_DIMENSION_TYPE.SyslogMessage]: {
    [MEASUREMENT_FAMILY.EventsSyslog]: ['ktappprotocol__event_syslog__STR05']
  },
  [GUIDED_DIMENSION_TYPE.SnmpTrapType]: {
    [MEASUREMENT_FAMILY.EventsSnmpTrap]: ['ktappprotocol__event_snmp_traps__INT00']
  },
  [GUIDED_DIMENSION_TYPE.SnmpTrapAgent]: {
    [MEASUREMENT_FAMILY.EventsSnmpTrap]: ['ktappprotocol__event_snmp_traps__kagent_id']
  },
  [GUIDED_DIMENSION_TYPE.DeviceConfigChangeCommitUser]: {
    [MEASUREMENT_FAMILY.EventsDeviceConfigChange]: ['ktappprotocol__event_deviceconf__STR02']
  },
  [GUIDED_DIMENSION_TYPE.DeviceConfigChangeCommitComment]: {
    [MEASUREMENT_FAMILY.EventsDeviceConfigChange]: ['ktappprotocol__event_deviceconf__STR03']
  },
  [GUIDED_DIMENSION_TYPE.DeviceConfigChangeAgent]: {
    [MEASUREMENT_FAMILY.EventsDeviceConfigChange]: ['ktappprotocol__event_deviceconf__kagent_id']
  }
};
const GUIDED_LOOKUP_KEY = exports.GUIDED_LOOKUP_KEY = {
  Device: 'device',
  Site: 'site',
  Label: 'label',
  Country: 'country',
  ASNumber: 'asNumber',
  InterfaceName: 'interface',
  InterfaceDescription: 'interfaceDescription',
  DeviceTag: 'deviceTag',
  SyslogFilterOptions: 'syslogFilterOptions',
  SnmpTrapFilterOptions: 'snmpTrapFilterOptions',
  DeviceConfigChangeFilterOptions: 'deviceConfigChangeFilterOptions'
};
const guidedTypeLookupKeys = exports.guidedTypeLookupKeys = {
  [GUIDED_DIMENSION_TYPE.Site]: GUIDED_LOOKUP_KEY.Site,
  [GUIDED_DIMENSION_TYPE.Device]: GUIDED_LOOKUP_KEY.Device,
  [GUIDED_DIMENSION_TYPE.Label]: GUIDED_LOOKUP_KEY.Label,
  [GUIDED_DIMENSION_TYPE.Country]: GUIDED_LOOKUP_KEY.Country,
  [GUIDED_DIMENSION_TYPE.ASNumber]: GUIDED_LOOKUP_KEY.ASNumber,
  [GUIDED_DIMENSION_TYPE.InterfaceName]: GUIDED_LOOKUP_KEY.InterfaceName,
  [GUIDED_DIMENSION_TYPE.InterfaceDescription]: GUIDED_LOOKUP_KEY.InterfaceDescription,
  [GUIDED_DIMENSION_TYPE.SyslogFacility]: GUIDED_LOOKUP_KEY.SyslogFilterOptions,
  [GUIDED_DIMENSION_TYPE.SyslogSeverity]: GUIDED_LOOKUP_KEY.SyslogFilterOptions
};
const guidedLookupFilterFieldByType = exports.guidedLookupFilterFieldByType = {
  [GUIDED_DIMENSION_TYPE.SyslogFacility]: 'ktappprotocol__event_syslog__INT05',
  [GUIDED_DIMENSION_TYPE.SyslogSeverity]: 'ktappprotocol__event_syslog__INT06'
};

/**
 * Resolves a guided type string (which may be a static GuidedDimensionType or a device tag
 * dimension key like `i_device_tags ->> 'color'`) to its corresponding GuidedLookupKey.
 * Returns undefined for types that have no associated lookup (e.g. IPAddress).
 */
function getGuidedTypeLookupKey(guidedType) {
  if (guidedType.startsWith(_deviceTagMeasurements.DEVICE_TAG_DIMENSION_PREFIX)) {
    return GUIDED_LOOKUP_KEY.DeviceTag;
  }
  return guidedTypeLookupKeys[guidedType];
}
function getGuidedDimensionOptions(type, measurement, measurements) {
  const family = getMeasurementFamily(measurement);
  if (!family) {
    return [];
  }
  const deviceTagKey = (0, _deviceTagMeasurements.getDeviceTagKeysByDisplayName)(measurements ?? [])[type];
  if (deviceTagKey !== undefined) {
    return [deviceTagKey];
  }
  return guidedDimensions[type]?.[family] ?? [];
}